import type { PrescribedProduct } from '@/types/patientPrescriptions.types';
import type { PatientPrescriptionStatus } from '@montugroup/pms-api-contracts';

export interface PrescriptionMedicationsTableRow extends PrescribedProduct {
  altRowColor: boolean;
  removeBorder?: boolean;
  expanded?: boolean;
  isRefillScript?: boolean;
  status: PatientPrescriptionStatus;
}

export const HIDE_CANCEL = 'hide';
export const DISABLE_CANCEL = 'disable';
export const ENABLE_CANCEL = 'enable';

export type CancelProductActionState = typeof HIDE_CANCEL | typeof DISABLE_CANCEL | typeof ENABLE_CANCEL;

export type CancelProductPredicate = (product: PrescriptionMedicationsTableRow) => CancelProductActionState;

export type CancelProductCallback = (productId: number, productName: string) => void;

export type OpenRefillPrescriptionUrl = (prescriptionId: number) => void;

export interface PrescriptionMedicationsTableProps {
  prescribedProducts?: PrescribedProduct[];
  isLoading?: boolean;
  onCancelProduct?: CancelProductCallback;
  isProductCancellable?: CancelProductPredicate;
  hasCancelPermissions?: boolean;
  prescriptionStatus: PatientPrescriptionStatus;
  openRefillPrescriptionUrl?: OpenRefillPrescriptionUrl;
}
